/* Death by Cross — leitor de revista (WebGL). Uso: {% render 'dbc-magazine' %} */
(() => {
'use strict';
function initReader(root) {

/* =====================================================================
   1. DADOS
   ===================================================================== */
// altura: tela inteira menos o cabeçalho fixo/grudado do site (se houver)
const stickyBottom = vh => {
  let b = 0;
  for (const y of [1, 30, 60, 90, 120, 150, 180]) for (const x of [window.innerWidth / 2, 24, window.innerWidth - 24]) {
    for (const el of document.elementsFromPoint(x, y)) {
      if (el === root || root.contains(el)) continue;
      for (let e = el; e && e !== document.body && e !== document.documentElement; e = e.parentElement) {
        const cs = getComputedStyle(e);
        if (cs.position === 'fixed' || cs.position === 'sticky') {
          const r = e.getBoundingClientRect(), t = parseFloat(cs.top);
          // fixo no topo: conta onde termina; grudado: conta onde termina quando estiver preso no topo
          const stuck = cs.position === 'fixed' ? (r.top <= 2 ? r.bottom : 0) : (isNaN(t) ? 0 : t + r.height);
          if (r.height < vh * 0.4) b = Math.max(b, stuck);
          break;
        }
      }
    }
  }
  return b;
};
const fitHeight = () => {
  if (document.fullscreenElement === root || document.webkitFullscreenElement === root || root.classList.contains('is-fs')) { root.style.height = ''; return; }
  const vh = (window.visualViewport && window.visualViewport.height) || window.innerHeight;
  // um pouco menor que a área livre, para a barra de cima e a de baixo caberem juntas na tela
  const free = vh - stickyBottom(vh), h = Math.max(440, Math.round(free * 0.93));
  root.style.height = h + 'px';
  root.style.scrollMarginTop = Math.round(vh - free + (free - h) / 2) + 'px';
};
fitHeight();
window.addEventListener('resize', fitHeight);
if (window.visualViewport) window.visualViewport.addEventListener('resize', fitHeight);
window.addEventListener('load', fitHeight);
const DATA = JSON.parse(root.querySelector('[data-dbcr-data]').textContent);
const PAGES = DATA.pages;
const P = PAGES.length;
const ASPECT = DATA.pageAspect || 1.36;
const ID_INDEX = new Map(PAGES.map((p, i) => [p.id, i]));
const TOC_INDEX = DATA.toc && ID_INDEX.has(DATA.toc.page) ? ID_INDEX.get(DATA.toc.page) : -1;
const TOC_ENTRIES = (DATA.toc && DATA.toc.entries) || [];
const errors = [];
window.addEventListener('error', e => errors.push(String(e.message || e)));
window.addEventListener('unhandledrejection', e => errors.push(String(e.reason)));

const $ = s => root.querySelector('[data-dbcr="' + s.slice(1) + '"]');
const APP = root;
const stage = $('#stage'), canvas = $('#gl'), grabEl = $('#grab'), tocEl = $('#toc');
$('#mag-title').textContent = DATA.title || 'Revista';
$('#mag-issue').textContent = DATA.issue || '';

/* =====================================================================
   2. IMAGENS DAS PÁGINAS (arquivo -> textura)
   Cada página é uma imagem da composição original. Carregamento sob demanda;
   enquanto não chega, a folha mostra a cor de fundo da página.
   ===================================================================== */
const pad2 = n => String(n).padStart(2, '0');
const hexRGB = h => { const n = parseInt(h.slice(1), 16); return [(n >> 16) / 255, ((n >> 8) & 255) / 255, (n & 255) / 255]; };
const pageImgs = new Map();
function loadPage(i) {
  let e = pageImgs.get(i);
  if (!e) {
    const img = new Image(); e = { img, ok: false, failed: false }; pageImgs.set(i, e);
    img.decoding = 'async';
    try { if (new URL(PAGES[i].src, location.href).origin !== location.origin) img.crossOrigin = 'anonymous'; } catch (_) {}
    img.onload = () => { e.ok = true; invalidatePage(i); };
    img.onerror = () => { e.failed = true; errors.push('Falha ao carregar ' + PAGES[i].src); };
    img.src = PAGES[i].src;
  }
  return e;
}
function tocLayout() {
  return TOC_ENTRIES.map(entry => ({ x: entry.rect[0], y: entry.rect[1], w: entry.rect[2], h: entry.rect[3], entry }));
}

/* =====================================================================
   3. MATEMÁTICA DA VIRADA
   Coordenadas locais da folha: lombada em x = 0, borda externa em x = W,
   y = 0 no topo. A folha é dobrada ao redor de um cilindro cujo eixo é a
   "linha de dobra" (ponto L, direção perpendicular a n). Pontos além da
   linha enrolam no cilindro de raio R e, depois de meia volta, voltam
   planos por cima, mostrando o verso. O ponto agarrado fica sob o cursor
   e a lombada nunca é dobrada.
   ===================================================================== */
const DEG = Math.PI / 180;
function computeFold(grab, vp, W, H) {
  const Rmax = W * 0.12;
  let vx = Math.min(0, vp.x - grab.x), vy = vp.y - grab.y;
  const pp = Math.max(0, Math.min(1, (grab.x - vp.x) / (2 * grab.x)));
  let D = Math.hypot(vx, vy);
  if (D < 0.5) return { active: false, pp: 0, R: 0, Lx: W * 3, Ly: 0, nx: -1, ny: 0, Rmax };
  // ângulo do puxão (0 = horizontal em direção à lombada); um leve viés pela altura agarrada
  let ang = Math.atan2(vy, -vx);
  ang += 14 * DEG * ((H / 2 - grab.y) / (H / 2)) * (1 - pp) * Math.min(1, D / (W * 0.25));
  const maxA = 68 * DEG; ang = Math.max(-maxA, Math.min(maxA, ang));
  const nx = -Math.cos(ang), ny = Math.sin(ang);
  D = Math.max(0, vx * nx + vy * ny);
  const cornerD = (Lx, Ly) => Math.max(Lx * nx + Ly * ny, Lx * nx + (Ly - H) * ny); // >0 = lombada dobrada
  let R = Math.min(Rmax, D / Math.PI), d, Lx, Ly;
  for (let k = 0; k < 4; k++) {
    d = (D + Math.PI * R) / 2; Lx = grab.x + nx * d; Ly = grab.y + ny * d;
    R = Math.min(Rmax, D / Math.PI, Math.max(0, -cornerD(Lx, Ly) * 0.5));
  }
  d = (D + Math.PI * R) / 2; Lx = grab.x + nx * d; Ly = grab.y + ny * d;
  const c = cornerD(Lx, Ly);
  if (c > 0) { Lx -= nx * c; Ly -= ny * c; }
  return { active: true, pp, R, Lx, Ly, nx, ny, Rmax };
}

/* =====================================================================
   4. WEBGL
   ===================================================================== */
const gl = canvas.getContext('webgl2', { antialias: true, alpha: true, premultipliedAlpha: true });
if (!gl) { $('#fallback').hidden = false; return; }

const FOLD_GLSL = `
uniform float uFoldOn, uR, uW, uH, uShAmt, uShadowAmt;
uniform vec2 uL, uN, uCanvas;
uniform sampler2D uShadow;
// sombra projetada pela própria folha (mapa gerado a cada quadro a partir da malha)
float castShadow(){ return 1.0 - uShadowAmt * texture(uShadow, gl_FragCoord.xy / uCanvas).r; }
// escurecimento de contato bem junto à dobra, no papel revelado
float foldShade(vec2 p){
  if (uFoldOn < 0.5) return 1.0;
  float d = dot(uL - p, uN);
  if (d > 0.0) {
    vec2 foot = p + uN * d;
    vec2 o = max(-foot, foot - vec2(uW, uH));
    float mask = exp(-length(max(o, 0.0)) / 6.0);
    return 1.0 - 0.22 * exp(-d / (uR * 0.45 + 3.0)) * uShAmt * mask;
  }
  return 1.0;
}
// lombada: as páginas afundam na costura; ax = distância da lombada / largura da página
float gutter(float ax, float spread){
  if (spread > 0.5) return 1.0 - 0.30 * exp(-ax / 0.028) - 0.08 * exp(-ax / 0.13) + 0.035 * exp(-pow((ax - 0.10) / 0.05, 2.0));
  return 1.0 - 0.10 * exp(-ax / 0.02);
}`;
const VIEW_GLSL = `uniform vec2 uStage; uniform float uSpineX, uTop, uMirror, uZoom; uniform vec2 uPan;
vec4 toClip(float sx, float sy, float z){ float X = uSpineX + sx, Y = uTop + sy;
  X = uStage.x * 0.5 + (X - uStage.x * 0.5) * uZoom + uPan.x; Y = uStage.y * 0.5 + (Y - uStage.y * 0.5) * uZoom + uPan.y; return vec4(X / uStage.x * 2.0 - 1.0, 1.0 - Y / uStage.y * 2.0, -z / 1000.0, 1.0); }`;

const SHEET_VS = `#version 300 es
layout(location=0) in vec3 aPos; layout(location=1) in vec3 aNorm; layout(location=2) in float aD; layout(location=3) in vec2 aUV;
${VIEW_GLSL}
out vec2 vUV; out vec3 vN; out vec2 vP; out float vD;
void main(){ vUV = aUV; vN = aNorm; vP = aPos.xy; vD = aD; gl_Position = toClip(uMirror * aPos.x, aPos.y, aPos.z); }`;
const SHEET_FS = `#version 300 es
precision highp float;
in vec2 vUV; in vec3 vN; in vec2 vP; in float vD;
uniform float uMirror; uniform sampler2D uFront, uBack; uniform float uHasFront, uHasBack, uGutter; uniform vec3 uPaper;
${FOLD_GLSL}
out vec4 o;
void main(){
  bool front = vN.z >= 0.0;
  float fu = uMirror > 0.0 ? vUV.x : 1.0 - vUV.x;
  vec3 c = front ? (uHasFront > 0.5 ? texture(uFront, vec2(fu, vUV.y)).rgb : uPaper)
                 : (uHasBack > 0.5 ? texture(uBack, vec2(1.0 - fu, vUV.y)).rgb : uPaper);
  vec3 N = normalize(vN); if (!front) N = -N; N.x *= uMirror;
  vec3 Ld = normalize(vec3(-0.30, -0.45, 1.0));
  float diff = max(dot(N, Ld), 0.0);
  float sh = (0.30 + 0.70 * diff) / (0.30 + 0.70 * Ld.z);
  vec3 Hh = normalize(Ld + vec3(0.0, 0.0, 1.0));
  float spec = max(pow(max(dot(N, Hh), 0.0), 36.0) - pow(Hh.z, 36.0), 0.0) * 0.07;
  c *= mix(1.0, gutter(vUV.x, uGutter), abs(N.z));
  o = vec4(min(c * min(sh, 1.06) + spec, vec3(0.985)), 1.0);
}`;
const QUAD_VS = `#version 300 es
layout(location=0) in vec2 aUnit;
${VIEW_GLSL}
uniform vec4 uRect; uniform float uZ;
out vec2 vS; out vec2 vUV;
void main(){ vec2 s = uRect.xy + aUnit * uRect.zw; vS = s; vUV = aUnit; gl_Position = toClip(s.x, s.y, uZ); }`;
const QUAD_FS = `#version 300 es
precision highp float;
in vec2 vS; in vec2 vUV;
uniform float uMirror; uniform sampler2D uTex; uniform float uHasTex, uKind, uGutter; uniform vec3 uPaper, uEdge;
uniform vec4 uRectA, uRectB;
uniform float uStackA, uStackB, uStackStep;
uniform sampler2D uShine; uniform float uHasShine, uTime;
${FOLD_GLSL}
out vec4 o;
float rectDist(vec2 p, vec4 r){ vec2 c = (r.xy + r.zw) * 0.5, h = (r.zw - r.xy) * 0.5; vec2 q = abs(p - c) - h; return length(max(q, 0.0)) + min(max(q.x, q.y), 0.0); }
bool inRect(vec2 p, vec4 r){ return p.x >= r.x && p.x <= r.z && p.y >= r.y && p.y <= r.w; }
// folhas empilhadas embaixo de um bloco de páginas: cada uma deslocada para fora e para baixo
vec4 stack(vec2 p, vec4 r, float n, float dir){
  if (n < 0.5 || inRect(p, r)) return vec4(0.0);
  for (int j = 1; j <= 12; j++) {
    if (float(j) > n) break;
    vec4 q = r + vec4(dir < 0.0 ? -1.0 : 0.0, 0.6, dir > 0.0 ? 1.0 : 0.0, 0.6) * uStackStep * float(j);
    if (inRect(p, q)) {
      float t = float(j) / max(n, 1.0);
      float e = min(min(p.x - q.x, q.z - p.x), q.w - p.y);          // distância à borda desta folha
      float line = smoothstep(0.0, 0.55 * uStackStep, e);            // fio escuro entre folhas
      vec3 col = uEdge * mix(0.95, 0.58, t) * mix(0.42, 1.0, line);
      return vec4(col, 1.0);
    }
  }
  return vec4(0.0);
}
void main(){
  vec2 pl = vec2(vS.x * uMirror, vS.y);
  float shade = castShadow();
  if (uKind > 0.5) {
    vec4 sa = uRectA.z > uRectA.x ? stack(vS, uRectA, uStackA, -1.0) : vec4(0.0);
    vec4 sb = uRectB.z > uRectB.x ? stack(vS, uRectB, uStackB, 1.0) : vec4(0.0);
    vec4 st = sa.a > 0.0 ? sa : sb;
    float grow = (max(uStackA, uStackB) * uStackStep);
    float a = 0.0;
    if (uRectA.z > uRectA.x) a = max(a, 0.30 * exp(-max(rectDist(vS - vec2(0.0, 5.0), uRectA + vec4(-grow, 0.0, 0.0, grow * 0.6)), 0.0) / 12.0));
    if (uRectB.z > uRectB.x) a = max(a, 0.30 * exp(-max(rectDist(vS - vec2(0.0, 5.0), uRectB + vec4(0.0, 0.0, grow, grow * 0.6)), 0.0) / 12.0));
    if (st.a > 0.0) { o = vec4(st.rgb * shade, 1.0); return; }
    float alpha = 1.0 - (1.0 - a) * shade;
    o = vec4(0.0, 0.0, 0.0, alpha);
    return;
  }
  vec3 c = uHasTex > 0.5 ? texture(uTex, vUV).rgb : uPaper;
  float ax = abs(vS.x) / uW;
  vec3 col = c * gutter(ax, uGutter) * shade;
  if (uHasShine > 0.5) {   // feixe de luz passando sobre as letras (máscara = só o texto)
    float m = texture(uShine, vUV).r;
    float sweep = vUV.x * 0.55 + vUV.y * 0.45;
    float pos = fract(uTime / 3.8) * 2.0 - 0.5;
    float band = exp(-pow((sweep - pos) / 0.075, 2.0)) + 0.35 * exp(-pow((sweep - pos) / 0.22, 2.0));
    col = mix(col, vec3(1.0, 0.86, 0.80), clamp(m * band * 0.85, 0.0, 1.0));
  }
  o = vec4(col, 1.0);
}`;
const SHADOW_VS = `#version 300 es
layout(location=0) in vec3 aPos;
${VIEW_GLSL}
uniform vec2 uOff;
out float vH;
void main(){ float h = max(aPos.z - 0.1, 0.0); vH = h; vec2 sp = vec2(uMirror * aPos.x, aPos.y) + uOff * h; gl_Position = toClip(sp.x, sp.y, 0.0); }`;
const SHADOW_FS = `#version 300 es
precision highp float;
in float vH; out vec4 o;
uniform float uHMin;
void main(){ if (vH < uHMin) discard; o = vec4(1.0); }`;
const BLUR_VS = `#version 300 es
layout(location=0) in vec2 aUnit;
void main(){ gl_Position = vec4(aUnit * 2.0 - 1.0, 0.0, 1.0); }`;
const BLUR_FS = `#version 300 es
precision highp float;
uniform sampler2D uSrc; uniform vec2 uSize, uDir; uniform float uSigma;
out vec4 o;
void main(){
  vec2 uv = gl_FragCoord.xy / uSize; float acc = 0.0, wsum = 0.0;
  for (int i = -24; i <= 24; i++) { float x = float(i) / uSigma; if (abs(x) > 3.0) continue; float w = exp(-0.5 * x * x); acc += texture(uSrc, uv + uDir * float(i)).r * w; wsum += w; }
  o = vec4(acc / wsum);
}`;

function compile(vsSrc, fsSrc) {
  const mk = (type, src) => { const s = gl.createShader(type); gl.shaderSource(s, src); gl.compileShader(s);
    if (!gl.getShaderParameter(s, gl.COMPILE_STATUS)) throw new Error(gl.getShaderInfoLog(s)); return s; };
  const p = gl.createProgram(); gl.attachShader(p, mk(gl.VERTEX_SHADER, vsSrc)); gl.attachShader(p, mk(gl.FRAGMENT_SHADER, fsSrc)); gl.linkProgram(p);
  if (!gl.getProgramParameter(p, gl.LINK_STATUS)) throw new Error(gl.getProgramInfoLog(p));
  const u = {}; const n = gl.getProgramParameter(p, gl.ACTIVE_UNIFORMS);
  for (let k = 0; k < n; k++) { const info = gl.getActiveUniform(p, k); u[info.name] = gl.getUniformLocation(p, info.name); }
  return { p, u };
}
const sheetProg = compile(SHEET_VS, SHEET_FS), quadProg = compile(QUAD_VS, QUAD_FS);
const shadowProg = compile(SHADOW_VS, SHADOW_FS), blurProg = compile(BLUR_VS, BLUR_FS);
// mapa de sombra (meia resolução): a folha é projetada no plano e desfocada conforme a altura
const SH = { w: 1, h: 1, tex: [null, null], fbo: [null, null], out: 0 };
function shadowTargets(w, h) {
  w = Math.max(1, w); h = Math.max(1, h);
  if (SH.w === w && SH.h === h && SH.tex[0]) return;
  SH.w = w; SH.h = h;
  for (let k = 0; k < 2; k++) {
    if (SH.tex[k]) { gl.deleteTexture(SH.tex[k]); gl.deleteFramebuffer(SH.fbo[k]); }
    const t = gl.createTexture(); gl.bindTexture(gl.TEXTURE_2D, t);
    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, w, h, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR); gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE); gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    const fb = gl.createFramebuffer(); gl.bindFramebuffer(gl.FRAMEBUFFER, fb);
    gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, t, 0);
    SH.tex[k] = t; SH.fbo[k] = fb;
  }
  gl.bindFramebuffer(gl.FRAMEBUFFER, null);
}

// malha da folha
/*MESH-BEGIN*/
// A malha é refeita a cada quadro em faixas paralelas à linha de dobra. O vinco (d = 0) e o fim
// da curva (d = πR) são sempre arestas da malha, então nenhum triângulo atravessa uma dobra:
// o papel não estica nem "craquela", em qualquer ângulo ou raio. A matemática da dobra não muda.
const MESH_STRIDE = 9, MESH_CURVE_STEPS = 48, MESH_MAX = 1600;
function buildSheetMesh(f, W, H, out) {
  const PI = Math.PI, E = 0.25;
  const rect = [[0, 0], [W, 0], [W, H], [0, H]];
  if (!f.active) f = { active: false, Lx: W * 3, Ly: 0, nx: -1, ny: 0, R: 0 };
  const R = f.R, dOf = (x, y) => (f.Lx - x) * f.nx + (f.Ly - y) * f.ny;
  const ds = rect.map(p => dOf(p[0], p[1])), dmin = Math.min(...ds), dmax = Math.max(...ds);
  const cuts = [0]; if (R > 0) for (let k = 1; k <= MESH_CURVE_STEPS; k++) cuts.push(PI * R * k / MESH_CURVE_STEPS);
  const breaks = [dmin, ...cuts.filter(c => c > dmin + 1e-6 && c < dmax - 1e-6), dmax];
  const clip = (poly, lim, keepAbove) => {
    const res = [];
    for (let k = 0; k < poly.length; k++) {
      const p = poly[k], q = poly[(k + 1) % poly.length], dp = dOf(p[0], p[1]) - lim, dq = dOf(q[0], q[1]) - lim;
      const inP = keepAbove ? dp >= -1e-9 : dp <= 1e-9, inQ = keepAbove ? dq >= -1e-9 : dq <= 1e-9;
      if (inP) res.push(p);
      if (inP !== inQ) { const t = dp / (dp - dq); res.push([p[0] + (q[0] - p[0]) * t, p[1] + (q[1] - p[1]) * t]); }
    }
    return res;
  };
  let n = 0;
  // zone: 0 = parte plana (frente), 1 = curva, 2 = parte virada (verso). Decidida pela faixa, não pelo
  // vértice, para que pontos exatamente sobre o vinco nunca misturem frente e verso no mesmo triângulo.
  const emit = (x, y, zone) => {
    const d = f.active ? dOf(x, y) : -1;
    let px = x, py = y, pz = 0, Nx = 0, Ny = 0, Nz = 1;
    if (zone === 1) {
      const dd = Math.min(PI * R, Math.max(0, d)), a = dd / R, si = Math.sin(a), co = Math.cos(a);
      px = x + f.nx * dd - f.nx * R * si; py = y + f.ny * dd - f.ny * R * si; pz = (R + E) * (1 - co); Nx = f.nx * si; Ny = f.ny * si; Nz = co;
      if (Math.abs(Nz) < 1e-3) Nz = 0;
    } else if (zone === 2) {
      const dd = Math.max(0, d), ex = dd - PI * R;
      px = x + f.nx * dd + f.nx * ex; py = y + f.ny * dd + f.ny * ex; pz = 2 * (R + E); Nz = -1;
    }
    const o = n * MESH_STRIDE;
    out[o] = px; out[o + 1] = py; out[o + 2] = pz + 0.1; out[o + 3] = Nx; out[o + 4] = Ny; out[o + 5] = Nz; out[o + 6] = d;
    out[o + 7] = x / W; out[o + 8] = y / H; n++;
  };
  for (let k = 0; k < breaks.length - 1; k++) {
    if (breaks[k + 1] - breaks[k] < 1e-6) continue;
    const poly = clip(clip(rect, breaks[k], true), breaks[k + 1], false);
    const mid = (breaks[k] + breaks[k + 1]) / 2, zone = !f.active || mid <= 0 ? 0 : (mid >= PI * R ? 2 : 1);
    for (let t = 1; t + 1 < poly.length && n + 3 <= MESH_MAX; t++) {
      emit(poly[0][0], poly[0][1], zone); emit(poly[t][0], poly[t][1], zone); emit(poly[t + 1][0], poly[t + 1][1], zone);
    }
  }
  return n;
}
/*MESH-END*/
const meshData = new Float32Array(MESH_MAX * MESH_STRIDE); let meshCount = 0;
const sheetVAO = gl.createVertexArray(); gl.bindVertexArray(sheetVAO);
const dynBuf = gl.createBuffer(); gl.bindBuffer(gl.ARRAY_BUFFER, dynBuf); gl.bufferData(gl.ARRAY_BUFFER, meshData.byteLength, gl.DYNAMIC_DRAW);
gl.enableVertexAttribArray(0); gl.vertexAttribPointer(0, 3, gl.FLOAT, false, MESH_STRIDE * 4, 0);
gl.enableVertexAttribArray(1); gl.vertexAttribPointer(1, 3, gl.FLOAT, false, MESH_STRIDE * 4, 12);
gl.enableVertexAttribArray(2); gl.vertexAttribPointer(2, 1, gl.FLOAT, false, MESH_STRIDE * 4, 24);
gl.enableVertexAttribArray(3); gl.vertexAttribPointer(3, 2, gl.FLOAT, false, MESH_STRIDE * 4, 28);
const quadVAO = gl.createVertexArray(); gl.bindVertexArray(quadVAO);
const quadBuf = gl.createBuffer(); gl.bindBuffer(gl.ARRAY_BUFFER, quadBuf); gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([0, 0, 1, 0, 0, 1, 1, 1]), gl.STATIC_DRAW);
gl.enableVertexAttribArray(0); gl.vertexAttribPointer(0, 2, gl.FLOAT, false, 0, 0);
gl.bindVertexArray(null);

function updateSheet(f, W, H) {
  meshCount = buildSheetMesh(f, W, H, meshData);
  gl.bindBuffer(gl.ARRAY_BUFFER, dynBuf); gl.bufferSubData(gl.ARRAY_BUFFER, 0, meshData, 0, meshCount * MESH_STRIDE);
}

// texturas com cache LRU
const texCache = new Map(); let clock = 0;
const aniso = gl.getExtension('EXT_texture_filter_anisotropic');
function upload(tex, c) {
  gl.bindTexture(gl.TEXTURE_2D, tex);
  gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, false); gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, false);
  gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, c); gl.generateMipmap(gl.TEXTURE_2D);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR_MIPMAP_LINEAR); gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE); gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
  if (aniso) gl.texParameterf(gl.TEXTURE_2D, aniso.TEXTURE_MAX_ANISOTROPY_EXT, 4);
}
function getTex(i) {
  if (i == null || i < 0 || i >= P) return null;
  const im = loadPage(i);
  if (!im.ok) return null;
  let e = texCache.get(i);
  if (!e) { e = { tex: gl.createTexture(), used: 0, dirty: true }; texCache.set(i, e); }
  if (e.dirty) { upload(e.tex, im.img); e.dirty = false; }
  e.used = ++clock;
  if (texCache.size > 10) {
    let old = null; for (const [k, v] of texCache) if (k !== i && (!old || v.used < old[1].used)) old = [k, v];
    if (old) { gl.deleteTexture(old[1].tex); texCache.delete(old[0]); }
  }
  return e.tex;
}
// máscaras de brilho (pages[].shine): carregadas sob demanda, uma textura por página
const REDUCED_MOTION = !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
const shineCache = new Map();
function getShineTex(i) {
  const src = PAGES[i] && PAGES[i].shine; if (!src) return null;
  let e = shineCache.get(i);
  if (!e) {
    e = { img: new Image(), ok: false, tex: null }; shineCache.set(i, e);
    try { if (new URL(src, location.href).origin !== location.origin) e.img.crossOrigin = 'anonymous'; } catch (_) {}
    e.img.onload = () => { e.ok = true; requestRender(); };
    e.img.src = src;
  }
  if (!e.ok) return null;
  if (!e.tex) { e.tex = gl.createTexture(); upload(e.tex, e.img); }
  return e.tex;
}
const shineVisible = () => !REDUCED_MOTION && document.visibilityState !== 'hidden' &&
  [visiblePages().L, visiblePages().R].some(k => k != null && PAGES[k].shine);
function invalidatePage(i) { const e = texCache.get(i); if (e) e.dirty = true; requestRender(); }
function invalidateAll() { texCache.forEach(e => (e.dirty = true)); requestRender(); }

/* =====================================================================
   5. ESTADO, LAYOUT E DESENHO
   spread: t = número de folhas viradas (esq. = página 2t-1, dir. = 2t)
   single: i = página visível
   ===================================================================== */
const S = { base: 0, shift: 0, mode: 'spread', t: 0, i: 0, W: 300, H: 408, spineX: 0, top: 0, sw: 1, sh: 1, dpr: 1 };
const Z = { z: 1, px: 0, py: 0, target: 1, pan: null, anim: null };
let turn = null, pending = null, lastFold = null, tocWasActive = false, introTimer = 0;
const paperRGB = hexRGB(DATA.pageBackground || '#18181b');
const EDGE_RGB = hexRGB(DATA.pageEdge || '#d9d6cf');  // cor do corte do papel na pilha

function visiblePages() {
  if (S.mode === 'single') return { L: null, R: S.i };
  const L = 2 * S.t - 1, R = 2 * S.t;
  return { L: L >= 0 && L < P ? L : null, R: R < P ? R : null };
}
function layout() {
  const r = stage.getBoundingClientRect();
  const wasSingle = S.mode === 'single';
  const single = r.width < 720 || r.width / Math.max(1, r.height) < 1.05;
  if (single !== wasSingle) {
    if (single) { const v = visiblePages(); S.i = v.R != null ? v.R : (v.L != null ? v.L : 0); }
    else S.t = Math.floor((S.i + 1) / 2);
  }
  S.mode = single ? 'single' : 'spread';
  const isFs = !!(document.fullscreenElement || document.webkitFullscreenElement) || APP.classList.contains('is-fs');
  const padX = single ? 16 : (isFs ? 20 : 28), padY = single ? 14 : (isFs ? 14 : 16);
  const W = Math.max(60, Math.floor(single ? Math.min(r.width - 2 * padX, (r.height - 2 * padY) / ASPECT)
                                         : Math.min((r.width - 2 * padX) / 2, (r.height - 2 * padY) / ASPECT)));
  S.W = W; S.H = Math.round(W * ASPECT); S.sw = r.width; S.sh = r.height;
  S.top = Math.round((r.height - S.H) / 2); S.base = Math.round(single ? (r.width - W) / 2 : r.width / 2);
  if (!turn) S.shift = shiftFor();
  S.spineX = Math.round(S.base + S.shift);
  S.dpr = Math.min(2, window.devicePixelRatio || 1);
  canvas.width = Math.round(r.width * S.dpr); canvas.height = Math.round(r.height * S.dpr);
  const gx = single ? S.spineX : S.spineX - W;
  Object.assign(grabEl.style, { left: gx + 'px', top: S.top + 'px', width: (single ? W : 2 * W) + 'px', height: S.H + 'px' });
  positionToc();
}
// deslocamento horizontal para manter centralizado o que está à vista
function shiftFor() {
  if (S.mode !== 'spread') return 0;
  const v = visiblePages();
  if (v.L == null && v.R != null) return -S.W / 2;   // capa fechada
  if (v.R == null && v.L != null) return S.W / 2;    // contracapa fechada
  return 0;
}
function shiftAfter(tr) { const t = S.t, i = S.i; tr.commit(); const v = shiftFor(); S.t = t; S.i = i; return v; }
function applyShift() {
  const x = Math.round(S.base + S.shift);
  if (x === S.spineX) return;
  S.spineX = x;
  grabEl.style.left = (S.mode === 'single' ? S.spineX : S.spineX - S.W) + 'px';
  if (tocActive()) positionToc();
}
function setFoldUniforms(prog, f, mirror) {
  const u = prog.u;
  gl.uniform2f(u.uStage, S.sw, S.sh); gl.uniform1f(u.uSpineX, S.spineX); gl.uniform1f(u.uTop, S.top); gl.uniform1f(u.uMirror, mirror);
  gl.uniform1f(u.uZoom, Z.z); gl.uniform2f(u.uPan, Z.px, Z.py);
  gl.uniform1f(u.uW, S.W); gl.uniform1f(u.uH, S.H);
  gl.uniform1f(u.uFoldOn, f && f.active ? 1 : 0);
  if (f) { gl.uniform2f(u.uL, f.Lx, f.Ly); gl.uniform2f(u.uN, f.nx, f.ny); gl.uniform1f(u.uR, f.R);
    gl.uniform1f(u.uShAmt, Math.max(0, Math.min(1, f.R / (f.Rmax * 0.5)))); }
  if (u.uPaper) gl.uniform3fv(u.uPaper, paperRGB);
  if (u.uCanvas) gl.uniform2f(u.uCanvas, canvas.width, canvas.height);
  if (u.uShadow) { gl.activeTexture(gl.TEXTURE2); gl.bindTexture(gl.TEXTURE_2D, SH.tex[SH.out]); gl.uniform1i(u.uShadow, 2); gl.activeTexture(gl.TEXTURE0); }
  if (u.uShadowAmt) gl.uniform1f(u.uShadowAmt, shadowAmt);
  if (u.uGutter) gl.uniform1f(u.uGutter, S.mode === 'spread' ? 1 : 0);
}
function sideX(side) { return side === 'L' ? -S.W : 0; }
function drawQuadPage(i, side) {
  if (i == null || i < 0 || i >= P) return;
  const u = quadProg.u, tex = getTex(i);
  gl.uniform4f(u.uRect, sideX(side), 0, S.W, S.H); gl.uniform1f(u.uZ, 0); gl.uniform1f(u.uKind, 0);
  gl.activeTexture(gl.TEXTURE0); gl.bindTexture(gl.TEXTURE_2D, tex); gl.uniform1i(u.uTex, 0); gl.uniform1f(u.uHasTex, tex ? 1 : 0);
  const st = REDUCED_MOTION ? null : getShineTex(i);
  gl.uniform1f(u.uHasShine, st ? 1 : 0); gl.uniform1f(u.uTime, performance.now() / 1000);
  if (st) { gl.activeTexture(gl.TEXTURE3); gl.bindTexture(gl.TEXTURE_2D, st); gl.uniform1i(u.uShine, 3); gl.activeTexture(gl.TEXTURE0); }
  gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
}
// quantas folhas ficam visíveis embaixo de cada bloco (espessura da pilha)
function stackLeaves() {
  const total = Math.ceil(P / 2), cap = 10, scale = n => Math.min(cap, Math.round(n * cap / Math.max(1, total)) + (n > 0 ? 1 : 0));
  if (S.mode === 'single') return { L: 0, R: scale(Math.ceil((P - 1 - S.i) / 2)) };
  const left = S.t, right = total - S.t;
  return { L: scale(Math.max(0, left - 1)), R: scale(Math.max(0, right - 1)) };
}
let shadowAmt = 0;
function renderShadow(f, mirror) {
  shadowTargets(Math.ceil(canvas.width / 4), Math.ceil(canvas.height / 4));
  SH.out = 0;
  shadowAmt = 0;
  for (let k = 0; k < 2; k++) { gl.bindFramebuffer(gl.FRAMEBUFFER, SH.fbo[k]); gl.viewport(0, 0, SH.w, SH.h); gl.clearColor(0, 0, 0, 0); gl.clear(gl.COLOR_BUFFER_BIT); }
  if (!turn || !f || !f.active) { gl.bindFramebuffer(gl.FRAMEBUFFER, null); return; }
  const hMax = 2 * (f.R + 0.25);
  shadowAmt = 0.45 * Math.max(0.35, Math.min(1, hMax / (f.Rmax * 0.5)));
  gl.disable(gl.DEPTH_TEST); gl.disable(gl.BLEND);
  // 1) silhueta da parte levantada, projetada no plano (luz quase de cima, um pouco do alto da página)
  gl.bindFramebuffer(gl.FRAMEBUFFER, SH.fbo[1]); gl.viewport(0, 0, SH.w, SH.h);
  gl.useProgram(shadowProg.p); gl.bindVertexArray(sheetVAO);
  const u = shadowProg.u;
  gl.uniform2f(u.uStage, S.sw, S.sh); gl.uniform1f(u.uSpineX, S.spineX); gl.uniform1f(u.uTop, S.top); gl.uniform1f(u.uMirror, mirror);
  gl.uniform1f(u.uZoom, Z.z); gl.uniform2f(u.uPan, Z.px, Z.py);
  gl.uniform2f(u.uOff, 0.04 * mirror, 0.12);
  gl.uniform1f(u.uHMin, Math.max(0.3, hMax - 0.05));   // só a parte já virada (aba plana) projeta sombra
  gl.drawArrays(gl.TRIANGLES, 0, meshCount);
  // 2) desfoque proporcional à altura da folha (penumbra cresce quando a folha sobe).
  //    Duas iterações separáveis em 1/4 da resolução: sem degraus, mesmo com penumbra larga.
  const sigma = Math.max(0.8, (2.0 + 0.24 * hMax) * S.dpr / 4) / Math.SQRT2, step = Math.min(sigma * 0.5, 1.25);
  gl.useProgram(blurProg.p); gl.bindVertexArray(quadVAO); gl.uniform2f(blurProg.u.uSize, SH.w, SH.h); gl.uniform1i(blurProg.u.uSrc, 0);
  gl.uniform1f(blurProg.u.uSigma, sigma / step);
  gl.activeTexture(gl.TEXTURE0);
  let src = 1;
  for (let it = 0; it < 2; it++) for (const dir of [[1, 0], [0, 1]]) {
    const dst = 1 - src;
    gl.bindFramebuffer(gl.FRAMEBUFFER, SH.fbo[dst]); gl.bindTexture(gl.TEXTURE_2D, SH.tex[src]);
    gl.uniform2f(blurProg.u.uDir, dir[0] * step / SH.w, dir[1] * step / SH.h); gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
    src = dst;
  }
  SH.out = src;
  gl.bindFramebuffer(gl.FRAMEBUFFER, null); gl.bindVertexArray(null);
}
function rectFor(side) { const x = sideX(side); return [x, 0, x + S.W, S.H]; }
function draw() {
  gl.viewport(0, 0, canvas.width, canvas.height);
  gl.clearColor(0, 0, 0, 0); gl.clearDepth(1); gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
  const f = turn ? computeFold(turn.grab, turn.vp, S.W, S.H) : null; lastFold = f;
  const mirror = turn ? turn.mirror : 1;
  if (turn) updateSheet(f, S.W, S.H);
  renderShadow(f, mirror);
  gl.viewport(0, 0, canvas.width, canvas.height);
  // quais lados têm papel (para a sombra no fundo)
  let present = { L: false, R: false }, statics;
  if (turn) { statics = turn.statics; statics.forEach(s => { if (s.i != null && s.i >= 0 && s.i < P) present[s.side] = true; }); present[turn.sheetSide] = true; }
  else { const v = visiblePages(); statics = [{ i: v.L, side: 'L' }, { i: v.R, side: 'R' }]; present.L = v.L != null; present.R = v.R != null; }

  // fundo: sombras projetadas
  gl.useProgram(quadProg.p); gl.bindVertexArray(quadVAO); setFoldUniforms(quadProg, f, mirror);
  gl.disable(gl.DEPTH_TEST); gl.depthMask(false); gl.enable(gl.BLEND); gl.blendFunc(gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
  const off = [1, 0, 0, 0], A = present.L ? rectFor('L') : off, B = present.R ? rectFor('R') : off;
  gl.uniform4f(quadProg.u.uRectA, ...A); gl.uniform4f(quadProg.u.uRectB, ...B);
  const lv = stackLeaves();
  gl.uniform1f(quadProg.u.uStackA, present.L ? lv.L : 0); gl.uniform1f(quadProg.u.uStackB, present.R ? lv.R : 0);
  gl.uniform1f(quadProg.u.uStackStep, Math.max(1.2, S.W / 340)); gl.uniform3fv(quadProg.u.uEdge, EDGE_RGB);
  gl.uniform4f(quadProg.u.uRect, -S.spineX - S.sw * 2, -S.top - S.sh * 2, S.sw * 5, S.sh * 5); gl.uniform1f(quadProg.u.uZ, -5); gl.uniform1f(quadProg.u.uKind, 1);
  gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);

  // páginas paradas
  gl.disable(gl.BLEND); gl.enable(gl.DEPTH_TEST); gl.depthFunc(gl.LEQUAL); gl.depthMask(true);
  statics.forEach(s => drawQuadPage(s.i, s.side));

  // folha em movimento
  if (turn) {
    gl.useProgram(sheetProg.p); gl.bindVertexArray(sheetVAO); setFoldUniforms(sheetProg, f, mirror);
    const ft = getTex(turn.front), bt = getTex(turn.back), u = sheetProg.u;
    gl.activeTexture(gl.TEXTURE0); gl.bindTexture(gl.TEXTURE_2D, ft); gl.uniform1i(u.uFront, 0); gl.uniform1f(u.uHasFront, ft ? 1 : 0);
    gl.activeTexture(gl.TEXTURE1); gl.bindTexture(gl.TEXTURE_2D, bt); gl.uniform1i(u.uBack, 1); gl.uniform1f(u.uHasBack, bt ? 1 : 0);
    gl.drawArrays(gl.TRIANGLES, 0, meshCount);
    gl.activeTexture(gl.TEXTURE0);
  }
  gl.bindVertexArray(null);
}
let rafPending = false;
function requestRender() { if (!rafPending) { rafPending = true; requestAnimationFrame(frame); } }
function frame(now) {
  rafPending = false;
  if (turn && turn.phase === 'anim') stepAnim(now);
  if (Z.anim) { const a = Z.anim, k = Math.min(1, (now - a.t0) / a.dur), e = easeInOut(k);
    Z.z = a.from.z + (a.to.z - a.from.z) * e; Z.px = a.from.px + (a.to.px - a.from.px) * e; Z.py = a.from.py + (a.to.py - a.from.py) * e;
    if (k >= 1) { Z.anim = null; clampPan(); } }
  try { draw(); } catch (e) { errors.push(String(e)); }
  if ((turn && turn.phase === 'anim') || Z.anim || shineVisible()) requestRender();
}

/* =====================================================================
   6. VIRADAS (arraste e automáticas)
   ===================================================================== */
const inRange = i => i != null && i >= 0 && i < P;
// verso físico da folha: página par (frente, à direita) tem no verso a ímpar seguinte, e vice-versa
const versoOf = k => { const v = k % 2 === 0 ? k + 1 : k - 1; return inRange(v) ? v : null; };
function makeStepTurn(dir) {
  if (S.mode === 'spread') {
    const t = S.t;
    if (dir === 'fwd' && 2 * t < P) return { mirror: 1, reverse: false, front: 2 * t, back: inRange(2 * t + 1) ? 2 * t + 1 : null,
      statics: [{ i: 2 * t - 1, side: 'L' }, { i: 2 * t + 2, side: 'R' }], sheetSide: 'R', commit: () => { S.t = t + 1; } };
    if (dir === 'back' && t > 0) return { mirror: -1, reverse: false, front: 2 * t - 1, back: 2 * t - 2,
      statics: [{ i: 2 * t, side: 'R' }, { i: 2 * t - 3, side: 'L' }], sheetSide: 'L', commit: () => { S.t = t - 1; } };
  } else {
    const i = S.i;
    if (dir === 'fwd' && i < P - 1) return { mirror: 1, reverse: false, front: i, back: versoOf(i), statics: [{ i: i + 1, side: 'R' }], sheetSide: 'R', commit: () => { S.i = i + 1; } };
    if (dir === 'back' && i > 0) return { mirror: 1, reverse: true, front: i - 1, back: versoOf(i - 1), statics: [{ i, side: 'R' }], sheetSide: 'R', commit: () => { S.i = i - 1; } };
  }
  return null;
}
function makeJumpTurn(target) {
  if (S.mode === 'spread') {
    const t = S.t, t2 = Math.floor((target + 1) / 2);
    if (t2 === t) return null;
    if (t2 > t) return { mirror: 1, reverse: false, front: 2 * t, back: inRange(2 * t2 - 1) ? 2 * t2 - 1 : null,
      statics: [{ i: 2 * t - 1, side: 'L' }, { i: 2 * t2, side: 'R' }], sheetSide: 'R', commit: () => { S.t = t2; } };
    return { mirror: -1, reverse: false, front: 2 * t - 1, back: 2 * t2,
      statics: [{ i: 2 * t, side: 'R' }, { i: 2 * t2 - 1, side: 'L' }], sheetSide: 'L', commit: () => { S.t = t2; } };
  }
  const i = S.i; if (target === i) return null;
  if (target > i) return { mirror: 1, reverse: false, front: i, back: versoOf(i), statics: [{ i: target, side: 'R' }], sheetSide: 'R', commit: () => { S.i = target; } };
  return { mirror: 1, reverse: true, front: target, back: versoOf(target), statics: [{ i, side: 'R' }], sheetSide: 'R', commit: () => { S.i = target; } };
}
const turnedPoint = g => ({ x: -g.x, y: g.y });
function startAuto(tr, duration = 640) {
  if (!tr) return false;
  const grab = { x: S.W, y: S.H * 0.58 };
  tr.grab = grab;
  const a = { ...grab }, b = turnedPoint(grab);
  tr.vp = tr.reverse ? { ...b } : { ...a };
  turn = tr; tr.phase = 'anim';
  tr.anim = { from: { ...tr.vp }, to: tr.reverse ? a : b, t0: performance.now(), dur: duration, arc: S.H * 0.07, ease: easeInOut, complete: true };
  tr.shiftFrom = S.shift; tr.shiftTo = shiftAfter(tr);
  syncUI(); requestRender(); return true;
}
const easeInOut = k => k < .5 ? 4 * k * k * k : 1 - Math.pow(-2 * k + 2, 3) / 2;
const easeOut = k => 1 - Math.pow(1 - k, 3);
function stepAnim(now) {
  const a = turn.anim, k = Math.min(1, (now - a.t0) / a.dur), e = a.ease(k);
  turn.vp = { x: a.from.x + (a.to.x - a.from.x) * e, y: a.from.y + (a.to.y - a.from.y) * e - Math.sin(Math.PI * e) * (a.arc || 0) };
  if (a.complete && turn.shiftTo !== undefined) { S.shift = turn.shiftFrom + (turn.shiftTo - turn.shiftFrom) * e; applyShift(); }
  if (k >= 1) endTurn(a.complete);
}
function endTurn(complete) {
  if (!turn) return;
  const tr = turn; turn = null;
  if (complete) tr.commit();
  S.shift = shiftFor(); applyShift();
  syncUI(); requestRender(); prewarm();
}
function finishAnim() { if (turn && turn.phase === 'anim') { turn.vp = { ...turn.anim.to }; endTurn(turn.anim.complete); } }
function release() {
  const tr = turn; if (!tr || tr.phase !== 'drag') return;
  const pp = Math.max(0, Math.min(1, (tr.grab.x - tr.vp.x) / (2 * tr.grab.x)));
  const v = velocity(tr);
  let toTurned = pp > 0.5;
  if (v < -0.35 && pp > 0.02) toTurned = true; else if (v > 0.35) toTurned = false;
  const to = toTurned ? turnedPoint(tr.grab) : { ...tr.grab };
  const dist = Math.hypot(to.x - tr.vp.x, to.y - tr.vp.y);
  tr.phase = 'anim';
  tr.anim = { from: { ...tr.vp }, to, t0: performance.now(), dur: Math.max(170, Math.min(520, dist / S.W * 420)), arc: 0, ease: easeOut,
    complete: tr.reverse ? !toTurned : toTurned };
  tr.shiftFrom = S.shift; tr.shiftTo = tr.anim.complete ? shiftAfter(tr) : S.shift;
  root.classList.remove('is-dragging');
  syncUI(); requestRender();
}
function velocity(tr) {
  const s = tr.samples; if (s.length < 2) return 0;
  const last = s[s.length - 1]; let first = s[0];
  if (performance.now() - last.t > 100) return 0; // parou antes de soltar: sem arremesso
  for (const p of s) if (last.t - p.t <= 90) { first = p; break; }
  const dt = last.t - first.t; return dt > 0 ? (last.x - first.x) / dt : 0;
}

/* ponteiro: coordenadas do "spread" (x relativo à lombada, y relativo ao topo da página) */
let stageRect = null;
function toSpread(e) { return { x: e.clientX - stageRect.left - S.spineX, y: e.clientY - stageRect.top - S.top }; }
function decideDir(pt) {
  if (S.mode === 'spread') { if (pt.x >= 0) return 'fwd'; return 'back'; }
  return pt.x >= S.W * 0.5 ? 'fwd' : 'back';
}
function isEdgeTap(pt, dir) {
  if (S.mode === 'spread') return dir === 'fwd' ? pt.x > S.W * 0.8 : pt.x < -S.W * 0.8;
  return dir === 'fwd' ? pt.x > S.W * 0.75 : pt.x < S.W * 0.25;
}
function clampPan() {
  const mx = Math.max(0, ((S.mode === 'single' ? S.W : 2 * S.W) * Z.z - S.sw) / 2 + 48), my = Math.max(0, (S.H * Z.z - S.sh) / 2 + 48);
  Z.px = Math.max(-mx, Math.min(mx, Z.px)); Z.py = Math.max(-my, Math.min(my, Z.py));
}
function setZoom(z) {
  if (turn && turn.phase === 'drag') return;
  finishAnim();
  const from = { z: Z.z, px: Z.px, py: Z.py }, to = { z, px: z === 1 ? 0 : Z.px * z / Math.max(1, Z.z), py: z === 1 ? 0 : Z.py * z / Math.max(1, Z.z) };
  Z.target = z; Z.anim = { from, to, t0: performance.now(), dur: 260 };
  APP.classList.toggle('is-zoomed', z > 1);
  const zb = $('#btn-zoom'); if (zb) { zb.setAttribute('aria-pressed', z > 1 ? 'true' : 'false'); zb.setAttribute('aria-label', z > 1 ? 'Diminuir zoom' : 'Ampliar'); }
  syncUI(); requestRender();
}
grabEl.addEventListener('pointerdown', e => {
  if (e.pointerType === 'mouse' && e.button !== 0) return;
  if (Z.target > 1) {   // ampliado: arrastar move a revista
    Z.pan = { id: e.pointerId, x: e.clientX, y: e.clientY, px: Z.px, py: Z.py };
    try { grabEl.setPointerCapture(e.pointerId); } catch (_) {}
    e.preventDefault(); return;
  }
  if (pending || (turn && turn.phase === 'drag')) return;
  if (turn) finishAnim();
  stageRect = stage.getBoundingClientRect();
  const pt = toSpread(e);
  pending = { id: e.pointerId, x0: e.clientX, y0: e.clientY, pt0: pt, dir: decideDir(pt), type: e.pointerType,
    hit: e.target.closest && e.target.closest('.toc-hit') };
  if (e.pointerType === 'mouse') e.preventDefault();
  try { grabEl.setPointerCapture(e.pointerId); } catch (_) {}
});
grabEl.addEventListener('pointermove', e => {
  if (Z.pan && e.pointerId === Z.pan.id) { Z.px = Z.pan.px + e.clientX - Z.pan.x; Z.py = Z.pan.py + e.clientY - Z.pan.y; clampPan(); requestRender(); return; }
  if (pending && e.pointerId === pending.id) {
    const moved = Math.hypot(e.clientX - pending.x0, e.clientY - pending.y0);
    if (moved < (pending.type === 'mouse' ? 4 : 8)) return;
    const tr = makeStepTurn(pending.dir);
    if (!tr) return;
    const p0 = pending; pending = null;
    const l0 = { x: p0.pt0.x * tr.mirror, y: p0.pt0.y };
    tr.grab = tr.reverse ? { x: S.W, y: Math.max(0, Math.min(S.H, l0.y)) } : { x: Math.max(l0.x, S.W * 0.5), y: Math.max(0, Math.min(S.H, l0.y)) };
    tr.l0 = l0; tr.pid = p0.id; tr.phase = 'drag'; tr.samples = [];
    turn = tr; root.classList.add('is-dragging'); syncUI();
  }
  if (turn && turn.phase === 'drag' && e.pointerId === turn.pid) {
    const pt = toSpread(e), l = { x: pt.x * turn.mirror, y: pt.y }, dx = l.x - turn.l0.x, dy = l.y - turn.l0.y;
    let vp = turn.reverse ? { x: -turn.grab.x + 2 * dx, y: turn.grab.y + dy } : { x: turn.grab.x + dx, y: turn.grab.y + dy };
    vp.x = Math.max(-turn.grab.x - S.W * 0.6, Math.min(turn.grab.x + S.W * 0.2, vp.x));
    vp.y = Math.max(-S.H * 0.8, Math.min(S.H * 1.8, vp.y));
    turn.vp = vp;
    const now = performance.now(); turn.samples.push({ t: now, x: vp.x }); if (turn.samples.length > 8) turn.samples.shift();
    requestRender();
  }
});
function pointerEnd(e, cancelled) {
  if (Z.pan && e.pointerId === Z.pan.id) { Z.pan = null; return; }
  if (pending && e.pointerId === pending.id) {
    const p = pending; pending = null;
    if (!cancelled) {
      if (p.hit && tocActive()) goToId(p.hit.dataset.target);
      else if (isEdgeTap(p.pt0, p.dir)) startAuto(makeStepTurn(p.dir));
    }
    syncUI(); return;
  }
  if (turn && turn.phase === 'drag' && e.pointerId === turn.pid) release();
}
grabEl.addEventListener('pointerup', e => { pointerEnd(e, false); try { grabEl.releasePointerCapture(e.pointerId); } catch (_) {} });
grabEl.addEventListener('pointercancel', e => pointerEnd(e, true));
grabEl.addEventListener('lostpointercapture', e => pointerEnd(e, true));
window.addEventListener('blur', () => { if (turn && turn.phase === 'drag') release(); pending = null; });
grabEl.addEventListener('dragstart', e => e.preventDefault());
grabEl.addEventListener('contextmenu', e => { if (turn) e.preventDefault(); });

/* =====================================================================
   7. NAVEGAÇÃO, SUMÁRIO E INTERFACE
   ===================================================================== */
function isBusy() { return !!turn; }
function step(dir) { if (turn && turn.phase === 'drag') return; finishAnim(); startAuto(makeStepTurn(dir)); }
function goToIndex(i) {
  if (!inRange(i) || (turn && turn.phase === 'drag')) return;
  finishAnim(); pending = null; loadPage(i);
  const tr = makeJumpTurn(i);
  if (tr) startAuto(tr, 720); else syncUI();
}
function goToId(id) { if (ID_INDEX.has(id)) goToIndex(ID_INDEX.get(id)); }

function tocSide() {
  if (TOC_INDEX < 0) return null;
  const v = visiblePages();
  if (v.L === TOC_INDEX) return 'L'; if (v.R === TOC_INDEX) return 'R'; return null;
}
function tocActive() { return Z.target === 1 && !Z.anim && !turn && tocSide() != null && !(pending && pending.dragging); }
function buildToc() {
  tocEl.innerHTML = '';
  tocLayout().forEach((row, k) => {
    const e = row.entry, b = document.createElement('button');
    b.type = 'button'; b.className = 'toc-hit'; b.dataset.target = e.target; b.style.setProperty('--i', k);
    b.textContent = e.label;
    b.setAttribute('aria-label', `${e.label}, página ${e.printed}`);
    b.addEventListener('click', ev => { if (ev.detail === 0) goToId(e.target); }); // teclado; o ponteiro é tratado no pointerup
    b.dataset.k = k; tocEl.appendChild(b);
  });
}
function positionToc() {
  const side = tocSide(); if (!side) return;
  const x0 = S.mode === 'single' ? 0 : (side === 'L' ? 0 : S.W);
  tocLayout().forEach((row, k) => {
    const b = tocEl.children[k]; if (!b) return;
    Object.assign(b.style, { left: (x0 + row.x * S.W) + 'px', top: (row.y * S.H) + 'px', width: (row.w * S.W) + 'px', height: (row.h * S.H) + 'px' });
  });
}
function syncUI() {
  const active = tocActive();
  if (active) positionToc();
  if (active !== tocWasActive) {
    const focused = tocEl.contains(document.activeElement);
    tocEl.hidden = !active;
    if (active) {
      tocEl.classList.remove('intro'); void tocEl.offsetWidth; tocEl.classList.add('intro');
      clearTimeout(introTimer); introTimer = setTimeout(() => tocEl.classList.remove('intro'), 2400);
    } else if (focused) grabEl.focus?.();
    tocWasActive = active;
  }
  const v = visiblePages(), label = i => PAGES[i].folio == null ? (i === 0 ? 'Capa' : 'Contracapa') : 'p. ' + pad2(PAGES[i].folio);
  const parts = [v.L, v.R].filter(x => x != null).map(label);
  $('#indicator').innerHTML = `<strong>${parts.join(' – ')}</strong><span class="total"> &nbsp;/&nbsp; ${P} páginas</span>`;
  const canBack = S.mode === 'spread' ? S.t > 0 : S.i > 0, canFwd = S.mode === 'spread' ? 2 * S.t < P : S.i < P - 1;
  $('#btn-prev').disabled = !canBack; $('#btn-next').disabled = !canFwd;
  if (!turn) $('#live').textContent = [v.L, v.R].filter(x => x != null).map(i => label(i) + ': ' + PAGES[i].label).join('; ');
}
const fsEl = () => document.fullscreenElement || document.webkitFullscreenElement;
function toggleFullscreen() {
  if (fsEl() || APP.classList.contains('is-fs')) {
    if (APP.classList.contains('is-fs')) APP.classList.remove('is-fs');
    else (document.exitFullscreen || document.webkitExitFullscreen).call(document);
  } else {
    const req = APP.requestFullscreen || APP.webkitRequestFullscreen;
    let p = null;
    try { p = req ? req.call(APP) : null; } catch (_) { p = null; }
    if (!req) APP.classList.add('is-fs');
    else if (p && p.catch) p.catch(() => APP.classList.add('is-fs'));
  }
  setTimeout(syncFs, 60);
}
function syncFs() {
  const on = !!fsEl() || APP.classList.contains('is-fs');
  const b = $('#btn-fs'); if (b) { b.setAttribute('aria-pressed', on ? 'true' : 'false'); b.setAttribute('aria-label', on ? 'Sair da tela cheia' : 'Tela cheia'); }
  window.dispatchEvent(new Event('resize'));
}
document.addEventListener('fullscreenchange', syncFs); document.addEventListener('webkitfullscreenchange', syncFs);
if ($('#btn-zoom')) $('#btn-zoom').addEventListener('click', () => setZoom(Z.target > 1 ? 1 : 2));
if ($('#btn-fs')) $('#btn-fs').addEventListener('click', toggleFullscreen);
if ($('#btn-close')) $('#btn-close').addEventListener('click', toggleFullscreen);
$('#btn-prev').addEventListener('click', () => step('back'));
$('#btn-next').addEventListener('click', () => step('fwd'));
$('#btn-toc').addEventListener('click', () => goToIndex(TOC_INDEX));
document.addEventListener('keydown', e => {
  if (e.target.closest && e.target.closest('input,textarea,select')) return;
  if (e.key === 'ArrowRight' || e.key === 'PageDown') { e.preventDefault(); step('fwd'); }
  else if (e.key === 'ArrowLeft' || e.key === 'PageUp') { e.preventDefault(); step('back'); }
  else if (e.key === 'Escape' && Z.target > 1) { setZoom(1); }
  else if (e.key === 'Escape' && APP.classList.contains('is-fs')) { toggleFullscreen(); }
  else if (e.key === 'Home') { e.preventDefault(); goToIndex(0); }
  else if (e.key === 'End') { e.preventDefault(); goToIndex(P - 1); }
});

// pré-carrega texturas vizinhas sem travar o gesto
let prewarmTimer = 0;
function prewarm() {
  clearTimeout(prewarmTimer);
  const v = visiblePages(), base = v.R != null ? v.R : (v.L || 0), list = [];
  for (let d = 1; d <= 4; d++) list.push(base + d, base - d - 1);
  const next = () => { if (turn) return; const i = list.shift(); if (i == null) return; if (inRange(i)) getTex(i); prewarmTimer = setTimeout(next, 30); };
  prewarmTimer = setTimeout(next, 120);
}

new ResizeObserver(() => {
  if (turn && turn.phase === 'drag') { const tr = turn; turn = null; root.classList.remove('is-dragging'); try { grabEl.releasePointerCapture(tr.pid); } catch (_) {} }
  finishAnim(); pending = null;
  layout(); syncUI(); draw();
}).observe(stage);
canvas.addEventListener('webglcontextlost', e => { e.preventDefault(); $('#fallback').hidden = false; });

buildToc(); layout(); syncUI(); requestRender(); prewarm();
// carrega o restante das páginas em segundo plano, sem bloquear a primeira virada
setTimeout(() => { let k = 0; const next = () => { if (k >= P) return; loadPage(k++); setTimeout(next, 120); }; next(); }, 1500);

// API de inspeção para testes
window.__reader = {
  state: () => ({ front: turn ? turn.front : null, back: turn ? turn.back : null, mode: S.mode, t: S.t, i: S.i, visible: visiblePages(), turning: !!turn, phase: turn && turn.phase, pending: !!pending, tocActive: tocActive(), W: S.W, H: S.H, spineX: S.spineX, top: S.top }),
  fold: () => lastFold, zoom: () => ({ ...Z, anim: !!Z.anim, pan: !!Z.pan }), setZoom, goToIndex, goToId, errors, toc: () => tocLayout().map(r => ({ ...r, target: r.entry.target, index: ID_INDEX.get(r.entry.target), printed: r.entry.printed })), loaded: () => [...pageImgs.values()].filter(e => e.ok).length
};
}
function boot() { document.querySelectorAll('[data-dbc-reader]:not([data-dbcr-ready])').forEach(el => { el.setAttribute('data-dbcr-ready', ''); initReader(el); }); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
